import { useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import { useInject } from '@vk-hr-tek/core/ioc';
import { RoleService } from '@vk-hr-tek/core/http';

import { UserRoleService } from '../../user/services';
import { UserRoleEnum } from '../types';

export const useRole = () => {
  const userRoleService = useInject<UserRoleService>(RoleService);
  const location = useLocation();

  const [role, setRole] = useState<UserRoleEnum>(userRoleService.get());

  useEffect(() => {
    const newRole = userRoleService.get();
    setRole(newRole);
  }, [location, userRoleService]);

  return [role] as [typeof role];
};
